import { createStore, useStore } from 'zustand';
import { UserLocation } from 'src/api/types';
import { createContext, useContext } from 'react';

interface Props {
  serverUserLocation: UserLocation | null;
}
interface State extends Props {
  setNodeUserLocation: (serverUserLocation: UserLocation) => void;
}

type Store = ReturnType<typeof createServerUserLocationStore>;

export const createServerUserLocationStore = (initProps: Props) => {
  const defaultProps: Props = {
    serverUserLocation: null
  };
  return createStore<State>()((set) => ({
    ...defaultProps,
    ...initProps,
    setNodeUserLocation: (serverUserLocation) => set({ serverUserLocation })
  }));
};

export const ServerUserLocationStoreContext = createContext<Store | null>(null);

const useServerUserLocationStore = () => {
  const store = useContext(ServerUserLocationStoreContext);
  if (store) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const serverUserLocation = useStore(store, (s) => s.serverUserLocation);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const setNodeUserLocation = useStore(store, (s) => s.setNodeUserLocation);

    return {
      serverUserLocation,
      setNodeUserLocation
    };
  }

  return {
    serverUserLocation: null,
    setNodeUserLocation: () => null
  };
};

export default useServerUserLocationStore;
